import { defineMessages, useIntl } from 'react-intl';
import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import AdvancedHotkey from './component';

export const messages = defineMessages({
  name: {
    description: 'navigationHotkeys.PaymentSettings',
    defaultMessage: 'Payment Settings',
    id: 'LfwSGp',
  },
});

export const hotkey = ['g', 'a', 'b'];
export const barcodeContent = '+NH4CKUS358N8=';

const GotoSubscriptionSettings = ({ children }) => {
  const intl = useIntl();
  const history = useHistory();
  const handler = useCallback(() => history.push('/settings/payments'), [history]);
  const hotkeyMetadata = useMemo(
    () => ({
      barcode: barcodeContent,
      displayHotkeyStrings: ['gab'],
      hotkey,
      handler,
      name: intl.formatMessage(messages.name),
      legacyCategory: 'navigation',
      isGlobal: true,
    }),
    [intl, handler],
  );

  return <AdvancedHotkey hotkey={hotkeyMetadata}>{children}</AdvancedHotkey>;
};

GotoSubscriptionSettings.propTypes = {
  children: PropTypes.node.isRequired,
};

export default GotoSubscriptionSettings;
